import { CatalogItemRow } from "./catalogItems.types";

export interface CatalogItemBulkActiveEligibility {
    archivableIds: string[];
    enablableIds: string[];
}

export function getCatalogItemBulkActiveEligibility(
    rows: Array<Pick<CatalogItemRow, "id" | "active">>,
): CatalogItemBulkActiveEligibility {
    return {
        archivableIds: rows.filter((row) => row.active).map((row) => row.id),
        enablableIds: rows.filter((row) => !row.active).map((row) => row.id),
    };
}
